import script from "./ItemList.vue?vue&type=script&setup=true&scoped=true&lang=js"
export * from "./ItemList.vue?vue&type=script&setup=true&scoped=true&lang=js"

import "./ItemList.vue?vue&type=style&index=0&id=53bfccd5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53bfccd5"]])

export default __exports__